((($) => {
    const key = 'dark_mode';
    const checkDayHours = () => {
        let today = new Date()
        let curHr = today.getHours()
        let res = 1;

        if (curHr > 0 && curHr < 6) {
            // console.log('good morning')
            res = 3;
        } else if (curHr < 18 && curHr >= 6) {
            // console.log('good afternoon')
            res = 2;
        } else {
            // console.log('good evening')
            res = 3;
        }
        // res = 3;
        // console.log('res',res,curHr);

        $('body').find('.dark-mode-btn').addClass(`day-h-${res}`);

        $('body').find('.dark-mode-btn').removeClass('dark-mode-hint');

        if (res === 3) {
            if (!isActiveDarkMode()) {
                $('body').find('.dark-mode-btn').addClass('dark-mode-hint');
            }
        } else {
            if (isActiveDarkMode()) {
                $('body').find('.dark-mode-btn').addClass('dark-mode-hint');
            }
        }

    };

    const isActiveDarkMode = () => {
        return parseInt(localStorage.getItem(key), 10) === 1;
    }

    const toggleDarkMode = (btn) => {
        let isActive = isActiveDarkMode();

        let icon = 'dark-mode--sun'

        if (isActive) {
            $('body').addClass('is-dark');
            icon = 'dark-mode--night';
            btn.removeClass('dark-mode--sun');
        } else {
            $('body').removeClass('is-dark');
            btn.removeClass('dark-mode--night');
        }

        btn.addClass(icon);

        checkDayHours();

    };

    $('body').on('click', '.dark-mode-btn', function (e) {
        e.preventDefault();
        const btn = $(this);
        let next = 'dark-mode--night';
        let isEnabled = -1;
        if ($(this).hasClass('dark-mode--sun')) {
            isEnabled = 1;
        }
        localStorage.setItem(key, isEnabled);
        toggleDarkMode(btn);
        const _data = {
            status: isEnabled,
            rtk: window.application.requestToken.key,
            rtv: window.application.requestToken.value,
        };
        $.ajax({
            url: '/ajax/dark-mode',
            method: 'get',
            data: _data,
            success: () => {
            },
            error: () => {
            },
        })
    });

    toggleDarkMode($('body').find('.dark-mode-btn'));

})(jQuery));
